import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import authSlice from "./slices/authSlice";
import supplierSlice from "./slices/supplierSlice";
import stockSlice from "./slices/stockSlice";
import billingSlice from "./slices/billingSlice";
import rootSaga from "./sagas";

const rootReducer = combineReducers({
  auth: authSlice,
  suppliers: supplierSlice,
  stock: stockSlice,
  billing: billingSlice,
});

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
